import { render, staticRenderFns } from "./VuuroLandlordOnboardingWizard.vue?vue&type=template&id=225d8a58&scoped=true"
import script from "./VuuroLandlordOnboardingWizard.vue?vue&type=script&lang=js"
export * from "./VuuroLandlordOnboardingWizard.vue?vue&type=script&lang=js"
import style0 from "./VuuroLandlordOnboardingWizard.vue?vue&type=style&index=0&id=225d8a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d8a58",
  null
  
)

export default component.exports